import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { AppWizardService } from '../services/app-product.service';
import { WizardStep } from '../models/app-product-state';

export const productEnterGuard: CanActivateFn = async () => {
	const appWizardService = inject(AppWizardService);
	await appWizardService.checkWizardStateValidity(WizardStep.PROD_SPEC);
	return true;
};
